import getFixedFilterInput from './getFixedFilterInput';

const buildGoalFilterInput = (
  goal: GeneralGoal,
  toDrillDowns: ({
    plates,
    variableDrillDowns,
  }: {
    plates?: FilterPlateType[] | undefined;
    variableDrillDowns?: VariableDrillDownType[] | undefined;
  }) => FixedFilter[],
): { filterInput: FilterInput; dateScope: DateRangeInput } => {
  return getFixedFilterInput(goal, toDrillDowns);
};

export default buildGoalFilterInput;
